import React from "react"
import { Flex, Text } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import { GuestStatus } from "sharedTypes"

type Props = {
  status: GuestStatus;
}

const getStatusText = (guestStatus: GuestStatus) => {
  switch (guestStatus) {
    case GuestStatus.Confirmed: return "Confirmed"
    case GuestStatus.Declined: return "Declined"
    case GuestStatus.Waitlisted: return "Waitlisted"
    default: return "Unconfirmed"
  }
}

const getStatusColor = (guestStatus: GuestStatus) => {
  switch (guestStatus) {
    case GuestStatus.Confirmed: return "blue.300"
    case GuestStatus.Declined: return "red.300"
    case GuestStatus.Waitlisted: return "yellow.300"
    default: return "gray.400"
  }
}

const ConfirmationStatusCell = ({ status }: Props) => (
  <Flex align="center">
    <Icon icon="dot" size={3} mr={2} color={getStatusColor(status)} flexShrink={0} />
    <Text fontSize="sm" noOfLines={1}>{getStatusText(status)}</Text>
  </Flex>
)

export default ConfirmationStatusCell
